import React, { useState, useEffect } from "react";
import { isAdmin, hasPermission, isMaster } from "../../../utils/checkPermission";
import { ErrorAccessDenied } from "../Error";
import { DashBoard } from "../../../components/Admin/Dashboard/Dashboard/DashBoard";
import { useLanguage, useSite } from "../../../contexts";
import { useCompany } from "../../../contexts/CompanyContext";
import { useAuth } from "../../../hooks";
import { Permission } from "../../../api";
import "./Dashboard.scss";

const permissionController = new Permission();

export function Dashboard() {
  const { translations } = useLanguage();
  const { accessToken, user: { role } } = useAuth();
  const t = (key) => translations[key] || key;

  const [siteSelected, setSiteSelected] = useState(null);
  const [companySelected, setCompanySelected] = useState(null);
  const [permissionsByRole, setPermissionsByRole] = useState([]);

  const { site } = useSite();
  const { company } = useCompany();

  const needsWelcome = (isMaster(role) || isAdmin(role)) && (
    !company || company === "" || company === "0"
  );

  useEffect(() => {
    setCompanySelected(company);
    setSiteSelected("");
  }, [company]);

  useEffect(() => {
    setSiteSelected(site);
  }, [site]);

  useEffect(() => {
    (async () => {
      try {
        setPermissionsByRole([]);
        if (role) {
          const response = await permissionController.getMyPermissions(accessToken, true);
          setPermissionsByRole(response);
        }
      } catch (error) {
        console.error(error);
        setPermissionsByRole([]);
      }
    })();
  }, [role]);

  if (!(isMaster(role) || isAdmin(role) || hasPermission(permissionsByRole, role._id, "dashboard", "view"))) {
    return (
      <div className="welcome-selector">
        <div className="welcome-selector__card">
          <h1 className="welcome-selector__title">{t("WELCOME")}</h1>
        </div>
      </div>
    );
  }

  if (needsWelcome) {
    return (
      <div className="welcome-selector">
        <div className="welcome-selector__card">
          <h1 className="welcome-selector__title">{t("WELCOME")}</h1>
          <p className="welcome-selector__subtitle">
            {t("welcome_dashboard_subtitle")}
          </p>
        </div>
      </div>
    );
  }

  return (
    <DashBoard
      siteSelected={siteSelected}
      companySelected={companySelected}
    />
  );
}
